export enum W9SubmissionMethod {
  Email = 'EMAIL',
  Pdf = 'PDF',
}
